import { SafeLocalStorage } from './localStorage';

import * as Sentry from '@sentry/nextjs';

export const LEADER_REDIRECT_URL = 'LEADER_REDIRECT_URL';

const CRIBL_DOMAIN = process.env.SHARED_DOMAIN;

export const setLeaderRedirectUrl = (toRedirectUrl: string): void => {
  try {
    const { hostname, protocol } = new URL(toRedirectUrl);

    if (protocol === 'https:' && CRIBL_DOMAIN && hostname.endsWith(CRIBL_DOMAIN)) {
      SafeLocalStorage.setItem(LEADER_REDIRECT_URL, toRedirectUrl);
    }
  } catch (err) {
    let errorMessage = 'Invalid \'from\' query param';

    if (err instanceof Error) {
      errorMessage += `: ${err.message}`;
    }

    Sentry.captureException(errorMessage);
  }
};

export const setLeaderRedirectUrlFromQuery = (): void => {
  const queryString = window.location.search;
  const toRedirectUrl = new URLSearchParams(queryString).get('from');
  setLeaderRedirectUrl(toRedirectUrl as string);
};

export const getCleanLeaderRedirectUrl = (): string | null => {
  const toRedirectUrl = SafeLocalStorage.getItem(LEADER_REDIRECT_URL);
  SafeLocalStorage.removeItem(LEADER_REDIRECT_URL);

  return toRedirectUrl;
};
